import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutNotice = (titleRef, contentRef, imgListState) => {
	const navigate = useNavigate()
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)
	const request = () => {
		fetchRequest('PUT', `/${rolePath}/notice/${idx}`, {
			title: titleRef?.current?.value,
			content: contentRef?.current?.value,
			img_list: imgListState,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				navigate(-1)
				break
			case 400:
				if (fetchResult?.data?.error_code === 'notice_idx')
					setAlert('공지사항 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'title')
					setAlert('제목을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'content')
					setAlert('본문을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'img_list')
					setAlert('이미지 목록을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('공지사항 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutNotice
